export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/3p_learning-05ba4e2975ba74783013cdf24becb444.svg";